import { render, staticRenderFns } from "./titlebox.vue?vue&type=template&id=aac3ce04&scoped=true&"
import script from "./titlebox.vue?vue&type=script&lang=js&"
export * from "./titlebox.vue?vue&type=script&lang=js&"
import style0 from "./titlebox.vue?vue&type=style&index=0&id=aac3ce04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac3ce04",
  null
  
)

export default component.exports